var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"qcw-load-more qcw-load-more-btn",on:{"click":_vm.loadMoreMessage}},[_c('span',[_vm._v("Load More")])])
}
var staticRenderFns = []

export { render, staticRenderFns }